import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
interface FAQAccordionProps {
  question: string;
  answer: string;
}
export function FAQAccordion({
  question,
  answer
}: FAQAccordionProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-gold/20 py-6" data-id="element-6">
      <button onClick={() => setIsOpen(!isOpen)} className="flex w-full justify-between items-center text-left focus:outline-none group" aria-expanded={isOpen} data-id="element-7">
        <span className="text-xl md:text-2xl font-serif font-semibold text-gold-light group-hover:text-gold transition-colors pr-8" data-id="element-8">
          {question}
        </span>
        <div className={`flex-shrink-0 w-8 h-8 rounded-full border border-gold/30 flex items-center justify-center transition-all duration-300 ${isOpen ? 'bg-gold/10 border-gold' : 'group-hover:border-gold'}`} data-id="element-9">
          <ChevronDown className={`w-5 h-5 text-gold transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-10" />
        </div>
      </button>
      <div className={`overflow-hidden transition-all duration-500 ease-in-out ${isOpen ? 'max-h-[500px] opacity-100 mt-4' : 'max-h-0 opacity-0'}`} data-id="element-11">
        <p className="text-light/80 leading-relaxed text-lg" data-id="element-12">{answer}</p>
      </div>
    </div>;
}